import React from 'react';

const CosmeticiIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 7.50058C0 7.22444 0.223858 7.00058 0.5 7.00058H5.5C5.77614 7.00058 6 7.22444 6 7.50058V13.0006C6 14.6574 4.65685 16.0006 3 16.0006C1.34315 16.0006 0 14.6574 0 13.0006V7.50058Z"
        fill={fill}
      />
      <path
        d="M1 5.5007H5V1.00053C5 0.257145 4.21769 -0.22635 3.55279 0.1061L1.55279 1.1061C1.214 1.27549 1 1.62176 1 2.00053V5.5007Z"
        fill={fill}
      />
      <path
        d="M9 5.50058C9 2.46301 11.4624 0.000579834 14.5 0.000579834C17.5376 0.000579834 20 2.46301 20 5.50058C20 8.53815 17.5376 11.0006 14.5 11.0006C11.4624 11.0006 9 8.53815 9 5.50058Z"
        fill={fill}
      />
      <path
        d="M13.75 12.7109C13.9964 12.7371 14.2466 12.7506 14.5 12.7506C14.7534 12.7506 15.0036 12.7371 15.25 12.7109V14.5006H17.5C17.9142 14.5006 18.25 14.8364 18.25 15.2506C18.25 15.6648 17.9142 16.0006 17.5 16.0006H11.5C11.0858 16.0006 10.75 15.6648 10.75 15.2506C10.75 14.8364 11.0858 14.5006 11.5 14.5006H13.75V12.7109Z"
        fill={fill}
      />
    </svg>
  );
};

export default CosmeticiIcon;
